<template>
    <UsageLimitModal :visible="true" @close="onClose" :list="[]" :upgrade-url="upgradeUrl">
        <template #description>
            <span>{{ t('upgradeDialogModal.useUpCredits') }}</span>
        </template>
    </UsageLimitModal>
</template>

<script setup lang="ts">
import { UsageLimitModal } from 'patsnap-biz';
import { useTrack } from '../../composables/use-track';
import { computed, onMounted } from 'vue';
import '@patsnap-biz/usage-limit-modal/lib/style';
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import { getCoreEurekaPricingUrl } from '@eureka/utils/core-redirect';

interface Props {
    callback: () => void;
    role?: 'personal_basic' | 'personal_pro';
    eventDetail?: Record<string, any>;
}

const props = withDefaults(defineProps<Props>(), {
    role: 'personal_basic',
});

const { t } = useI18n({
    messages: {
        cn: {
            upgradeDialogModal: {
                useUpCredits: '当前积分余额不足，请升级套餐或联系销售获取更多积分。',
            },
        },
        en: {
            upgradeDialogModal: {
                useUpCredits: 'Your credit balance is insufficient. Please upgrade your plan or contact sales to get more credits.',
            },
        },
        jp: {
            upgradeDialogModal: {
                useUpCredits: 'クレジット残高が不足しています。プランをアップグレードするか、営業担当者にお問い合わせください。',
            },
        },
        tw: {
            upgradeDialogModal: {
                useUpCredits: '目前積分餘額不足，請升級方案或聯絡銷售取得更多積分。',
            },
        },
    },
});

const track = useTrack();

const upgradeUrl = computed(() => {
    const triggerSource = _.get(props.eventDetail, 'trigger_source', 'paywall');
    const agentName = _.get(props.eventDetail, 'agents')?.join(',') || _.get(props.eventDetail, 'agent_name');
    return getCoreEurekaPricingUrl(window.location.href, { triggerSource, agentName, headerType: 'feature_upgrade_required' });
});

onMounted(() => {
    const agentName = _.get(props.eventDetail, 'agents');

    track({
        eventType: 'SS EUREKA UPGRADE PAGE',
        sourceType: 'upgrade_trigger',
        moduleType: 'LS',
        eventDetail: {
            product_line: 'eureka_ls',
            agent_name: agentName?.join(','),
            ...(props.eventDetail || {}),
        },
    })
})

function onClose() {
    props.callback();
}
</script>

<style>
.patsnap-biz-usage-limit-modal .patsnap-biz-usage-limit-modal__list-tick {
    @apply shrink-0;
}

.patsnap-biz-usage-limit-modal .patsnap-biz-usage-limit-modal__button {
    width: 304px;
    max-width: 100%;
}

</style>
